// @flow

import { type IncomingPayment } from './types';

export function getDocument(incomingPayment: IncomingPayment): ?string {
  return incomingPayment['document'];
}
